<h1 class="soft-text-xl mt-2 mb-3 mr-2 ml-2">Preis anpassen</h1>

<form [formGroup]="form" class="">
  @if (preisebene) {
    <div class="c column center-v bordered" style="box-sizing: border-box">
      <span class="soft-overline mt-1">Preisebene</span>
      <span class="soft-text mt-2 mb-1">{{ preisebene?.preisebene }} - {{ preisebene?.bezeichnung }}</span>
    </div>
  }

  <div class="c row center-v no-wrap mt-2">
    <div class="c column center-v bordered mr-2" style="box-sizing: border-box">
      <span class="soft-overline mt-1">Aktueller Preis (inkl. USt)</span>
      <span class="soft-text mt-2 mb-1">{{ price | currency:'EUR' }}</span>
    </div>

    <div class="flex flex-col center-v w-full ml-2" style="box-sizing: border-box">
      <label for="newPrice" class="soft-label top mt-1">Neuer Preis</label>
      <soft-number-input id="newPrice" type="tel" class="soft-input mt-1" formControlName="price" ></soft-number-input>
    </div>
  </div>

  <button class="soft-button primary custom-button mt-2" type="submit" [disabled]="form.invalid" (click)="closeDialog()">Speichern</button>
</form>
